import PropTypes from 'prop-types';
import React from 'react';
import { connectToStores } from 'fluxible-addons-react';
import Immutable from 'immutable';

@connectToStores(['PortalUserStore'], (context, props) => {
  const PortalUserStore = context.getStore('PortalUserStore');

  const originalProps = Immutable.fromJS(props);
  let shouldRender = false;
  const loggedIn = PortalUserStore.userLoggedIn();
  if (props.role) {
    if (PortalUserStore.userHasRole(props.role)) {
      shouldRender = true;
    }
  } else if (
    (props.hideWhenAuthenticated && !loggedIn) ||
    (!props.hideWhenAuthenticated && loggedIn)
  ) {
    shouldRender = true;
  }

  const newProps = originalProps.set('shouldRender', shouldRender);

  return newProps.toJS();
})
class ProtectedComponent extends React.Component {
  static propTypes = {
    shouldRender: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    alternateComponent: PropTypes.func,
    role: PropTypes.string,
    hideWhenAuthenticated: PropTypes.bool
  };

  render() {
    const { shouldRender, children, alternateComponent } = this.props;
    let component = null;

    if (shouldRender) {
      component = children;
    } else if (alternateComponent) {
      component = alternateComponent();
    }

    return component;
  }
}

export default ProtectedComponent;



// WEBPACK FOOTER //
// ./src/components/ProtectedComponent.js